import { render, staticRenderFns } from "./AttendanceApprovalDlg.vue?vue&type=template&id=124035ec&scoped=true&"
import script from "./AttendanceApprovalDlg.vue?vue&type=script&lang=js&"
export * from "./AttendanceApprovalDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124035ec",
  null
  
)

export default component.exports